import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RecognizeService } from 'src/app/services/recognize.service';
import { AppStorageKey } from 'src/app/static';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-receive-recognize',
  templateUrl: './receive-recognize.component.html',
  styleUrls: ['./receive-recognize.component.scss'],
})
export class ReceiveRecognizeComponent implements OnInit {

  @Input() recognize;
  @Input () shipping;
  read: boolean = false;

  hasCustomColors: boolean = false;

  constructor(private modalController:ModalController, private recognizesService:RecognizeService, private storage: Storage) { }

  ngOnInit() {
    this.setCustomColors();
  }

  async setCustomColors(){
    await this.storage.get(AppStorageKey.HasCustomColors).then(
      data => {
        if(data) {
          this.hasCustomColors = data;
        } 
      },
      error => {
        console.log(error);
      }
    );
  }

  close(){
    this.modalController.dismiss({'read': this.read});
  }

  async postMark(){
    let data :any = {
      acknowledgment_shipping_id: this.shipping.id,
      status: "Read"
    }
    this.recognizesService.postRecognizeSeen(data).subscribe(response => {
      if(response['status'] == 200){
        this.read = true;
        this.close();
      }
    });
  }

}
